import React, { useState } from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { 
  Layout, 
  Menu, 
  theme, 
  Avatar, 
  Space, 
  Typography, 
  Button,
  Badge,
  Dropdown,
  Drawer
} from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardOutlined,
  ShoppingOutlined,
  AppstoreOutlined,
  TableOutlined,
  ShoppingCartOutlined,
  LogoutOutlined,
  UserOutlined,
  ScheduleOutlined,
  DownOutlined 
} from '@ant-design/icons';
import { FaUniversity, FaBuilding, FaChartLine } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../api/Api';
import { useRef } from 'react';

const { Header, Sider, Content } = Layout;
const { Text } = Typography;

const Home = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [selectedKey, setSelectedKey] = useState(['1']);
  const [openKeys, setOpenKeys] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [nome, setNome] = useState('');
  const [pedidos, setPedidos] = useState(0);
  const [perfil, setPerfil] = useState('');
  const prevPedidosRef = useRef(0);

  // Obter perfil do token
  useEffect(() => {
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      if (token && token.perfil) {
        setPerfil(token.perfil);
      }
    } catch (error) {
      console.error('Erro ao obter perfil:', error);
    }
  }, []);

  // Verificação de tempo de sessão
  useEffect(() => {
    const loginTime = parseInt(localStorage.getItem("loginTime"), 10) || Date.now();
    localStorage.setItem("loginTime", loginTime);

    const now = Date.now();
    const expired = now - loginTime > 3600000; // 1 hora

    if (expired) {
      logout();
      return;
    }

    const remainingTime = 3600000 - (now - loginTime);
    const timeout = setTimeout(logout, remainingTime);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    fetchData(); // chama imediatamente ao montar

    const interval = setInterval(() => {
      fetchData();  
    }, 6000);  

    return () => clearInterval(interval);
  }, []);

  const playNotificationSound = () => {
    const audio = new Audio('https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3');
    audio.play().catch(err => console.log('Erro ao tocar som (interação necessária):', err));
  };

  const fetchData = async () => {
    try {
      const dados = await Api.ListUserId();
      const _pedidos = await Api.CountPedidos();
      const novoTotal = _pedidos.id;

      // Detecção de novo pedido
      if (prevPedidosRef.current !== 0 && novoTotal > prevPedidosRef.current) {
        playNotificationSound();
        toast.success(`🔔 Novo pedido recebido!`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
      }

      setPedidos(novoTotal);
      prevPedidosRef.current = novoTotal;
      setNome(dados.nome);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    }
  };

  useEffect(() => {
    let newSelectedKey = ['1'];
    
    if (location.pathname.includes('/produtos')) {
      newSelectedKey = ['2'];
    } else if (location.pathname.includes('/categorias')) {
      newSelectedKey = ['3'];
    } else if (location.pathname.includes('/mesas')) {
      newSelectedKey = ['4'];
    } else if (location.pathname.includes('/pedidos')) {
      newSelectedKey = ['5'];
    } else if (location.pathname.includes('/usuarios')) {
      newSelectedKey = ['6'];
    } else if (location.pathname.includes('/estoque')) {
      newSelectedKey = ['7-1'];
    } else if (location.pathname.includes('/baixa')) {
      newSelectedKey = ['7-2'];
    } else if (location.pathname.includes('/inventario')) {
      newSelectedKey = ['7-3'];
    } else if (location.pathname.includes('/contas')) {
      newSelectedKey = ['8'];
    } else if (location.pathname.includes('/empresa')) {
      newSelectedKey = ['9'];
    } 
     else if (location.pathname.includes('/relatorio_produtos_vendidos')) {
      newSelectedKey = ['10-1'];
    }
     else if (location.pathname.includes('/documentos')) {
      newSelectedKey = ['10-2'];
    }
   else if (location.pathname.includes('/pedidos_cancelados')) {
      newSelectedKey = ['10-3'];
    }
    
    setSelectedKey(newSelectedKey);
    
    if (location.pathname.includes('/estoque') || 
        location.pathname.includes('/baixa') || 
        location.pathname.includes('/inventario')) {
      setOpenKeys(['7']);
    } 
    else if (location.pathname.includes('/relatorio_produtos_vendidos') || 
        location.pathname.includes('/documentos') || 
        location.pathname.includes('/pedidos_cancelados')) {
      setOpenKeys(['10']);
    } 
    else {
 
      setOpenKeys([]);
    }
  }, [location.pathname]);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("loginTime");
    window.location.href = "/";
  };

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const userMenuItems = [
    {
      key: '1',
      icon: <LogoutOutlined />,
      label: 'Sair',
      danger: true,
      onClick: logout
    },
  ];

  // Submenu de Estoque
  const estoqueSubMenu = {
    key: '7',
    icon: <ScheduleOutlined />,
    label: 'Estoque',
    profiles: ['ADMINISTRADOR', 'GESTOR DE ESTOQUE'],
    children: [
      {
        key: '7-1',
        label: 'Entrada em estoque',
        onClick: () => {
          navigate('/estoque');
          setOpenKeys(['7']); // Manter aberto ao clicar em um item do submenu
          setMobileOpen(false); // Fechar drawer no mobile
        },
        profiles: ['ADMINISTRADOR', 'GESTOR DE ESTOQUE']
      },
      {
        key: '7-2',
        label: 'Baixa',
        onClick: () => {
          navigate('/baixa');
          setOpenKeys(['7']); // Manter aberto ao clicar em um item do submenu
          setMobileOpen(false); // Fechar drawer no mobile
        },
        profiles: ['ADMINISTRADOR', 'GESTOR DE ESTOQUE']
      },
      {
        key: '7-3',
        label: 'Inventário',
        onClick: () => {
          navigate('/inventario');
          setOpenKeys(['7']); // Manter aberto ao clicar em um item do submenu
          setMobileOpen(false); // Fechar drawer no mobile
        },
        profiles: ['ADMINISTRADOR', 'GESTOR DE ESTOQUE']
      }
    ]
  };

  const relatorioSubMenu = {
    key: '10',
    icon: <FaChartLine />,
    label: 'Relatórios',
    profiles: ['ADMINISTRADOR'],
    children: [
      {
        key: '10-1',
        label: 'Produtos vendidos',
        onClick: () => {
          navigate('/relatorio_produtos_vendidos');
          setOpenKeys(['10']); // Manter aberto ao clicar em um item do submenu
          setMobileOpen(false); // Fechar drawer no mobile
        },
         profiles: ['ADMINISTRADOR'],
      },
       {
        key: '10-2',
        label: 'Documentos',
        onClick: () => {
          navigate('/documentos');
          setOpenKeys(['10']); // Manter aberto ao clicar em um item do submenu
          setMobileOpen(false); // Fechar drawer no mobile
        },
         profiles: ['ADMINISTRADOR'],
      },
      {
        key: '10-3',
        label: 'Pedidos cancelados',
        onClick: () => {
          navigate('/pedidos_cancelados');
          setOpenKeys(['10']); // Manter aberto ao clicar em um item do submenu
          setMobileOpen(false); // Fechar drawer no mobile
        },
         profiles: ['ADMINISTRADOR'],
      },
      
    ]
  };



  // Menu completo
  const allMenuItems = [
    {
      key: '1',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
      onClick: () => {
        navigate('/dashboard');
        setOpenKeys([]); // Fechar todos os submenus
        setMobileOpen(false); // Fechar drawer no mobile
      },
      profiles: ['ADMINISTRADOR', 'GESTOR DE ESTOQUE', 'VENDAS/CAIXA']
    },
    {
      key: '2',
      icon: <ShoppingOutlined />,
      label: 'Produtos',
      onClick: () => {
        navigate('/produtos');
        setOpenKeys([]); // Fechar todos os submenus
        setMobileOpen(false); // Fechar drawer no mobile
      },
      profiles: ['ADMINISTRADOR', 'GESTOR DE ESTOQUE']
    },
    {
      key: '3',
      icon: <AppstoreOutlined />,
      label: 'Categorias',
      onClick: () => {
        navigate('/categorias');
        setOpenKeys([]); // Fechar todos os submenus
        setMobileOpen(false); // Fechar drawer no mobile
      },
      profiles: ['ADMINISTRADOR', 'GESTOR DE ESTOQUE']
    },
    {
      key: '4',
      icon: <TableOutlined />,
      label: 'Mesas',
      onClick: () => {
        navigate('/mesas');
        setOpenKeys([]); // Fechar todos os submenus
        setMobileOpen(false); // Fechar drawer no mobile
      },
      profiles: ['ADMINISTRADOR', 'VENDAS/CAIXA']
    },
    {
      key: '5',
      icon: <ShoppingCartOutlined />,
      label: (
        <span>
          Pedidos
          {pedidos > 0 && (
            <Badge 
              count={pedidos} 
              style={{ 
                marginLeft: 8,
                background: 'rgba(255,255,255,0.9)',
                color: '#d94452'
              }} 
            />
          )}
        </span>
      ),
      onClick: () => {
        navigate('/pedidos');
        setOpenKeys([]); // Fechar todos os submenus
        setMobileOpen(false); // Fechar drawer no mobile
      },
      profiles: ['ADMINISTRADOR', 'VENDAS/CAIXA']
    },
    {
      key: '6',
      icon: <UserOutlined />,
      label: 'Usuários',
      onClick: () => {
        navigate('/usuarios');
        setOpenKeys([]); // Fechar todos os submenus
        setMobileOpen(false); // Fechar drawer no mobile
      },
      profiles: ['ADMINISTRADOR']
    },
    estoqueSubMenu,
    {
      key: '8',
      icon: <FaUniversity />,
      label: 'Contas',
      onClick: () => {
        navigate('/contas');
        setOpenKeys([]); // Fechar todos os submenus
        setMobileOpen(false); // Fechar drawer no mobile
      },
      profiles: ['ADMINISTRADOR']
    },
    {
      key: '9',
      icon: <FaBuilding />,
      label: 'Empresa',
      onClick: () => {
        navigate('/empresa');
        setOpenKeys([]); // Fechar todos os submenus
        setMobileOpen(false); // Fechar drawer no mobile
      },
      profiles: ['ADMINISTRADOR']
    },
    relatorioSubMenu
  ];

  // Filtragem de menu baseada no perfil
  const menuItems = allMenuItems.filter(item => {
    if (!item.profiles) return true;
    return item.profiles.includes(perfil);
  }).map(item => {
    if (item.children) {
      return {
        ...item,
        children: item.children.filter(child => {
          if (!child.profiles) return true;
          return child.profiles.includes(perfil);
        })
      };
    }
    return item;
  });

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find(key => !openKeys.includes(key));
    setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
  };

  // Componente de Sidebar reutilizável
  const SidebarContent = ({ isCollapsed }) => (
    <>
      {/* Logo */}
      <div style={{
        height: 80,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '12px 16px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        marginBottom: 8
      }}>
        {!isCollapsed ? (
          <img 
            src="/OTUMALOGOBT.png" 
            alt="OTUMA"
            style={{
              width: 220,
              height: 'auto',
              objectFit: 'contain',
              filter: 'brightness(0) invert(1) drop-shadow(0 2px 4px rgba(0,0,0,0.3))'
            }}
          />
        ) : (
          <img 
            src="/OTUMASIMBOLO.png" 
            alt="OTUMA"
            style={{
              width: 56,
              height: 56,
              objectFit: 'contain',
              filter: 'brightness(0) invert(1) drop-shadow(0 2px 4px rgba(0,0,0,0.3))'
            }}
          />
        )}
      </div>

      {/* Container com scroll para o menu */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        paddingBottom: 16,
        /* Estilos de scrollbar personalizados */
        scrollbarWidth: 'thin',
        scrollbarColor: 'rgba(255, 255, 255, 0.3) transparent'
      }}>
        {/* Menu Principal */}
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={selectedKey}
          openKeys={openKeys}
          onOpenChange={onOpenChange}
          style={{
            background: 'transparent',
            borderRight: 0,
            marginTop: 24,
            padding: '0 12px'
          }}
          items={menuItems.map(item => {
            if (item.children) {
              // Submenu com children
              return {
                ...item,
                label: (
                  <span style={{
                    fontWeight: 500,
                    fontSize: 15,
                    color: openKeys.includes(item.key) || selectedKey.some(key => key.startsWith(item.key + '-')) ? 'white' : 'rgba(255,255,255,0.85)'
                  }}>
                    {item.label}
                  </span>
                ),
                style: {
                  borderRadius: 8,
                  marginBottom: 8,
                  background: openKeys.includes(item.key) || selectedKey.some(key => key.startsWith(item.key + '-')) ? 'rgba(255,255,255,0.15)' : 'transparent',
                  transition: 'all 0.2s'
                },
                children: item.children.map(child => ({
                  ...child,
                  label: (
                    <span style={{
                      fontWeight: 400,
                      fontSize: 14,
                      color: selectedKey.includes(child.key) ? 'white' : 'rgba(255,255,255,0.85)'
                    }}>
                      {child.label}
                    </span>
                  ),
                  style: {
                    borderRadius: 6,
                    marginBottom: 4,
                    background: selectedKey.includes(child.key) ? 'rgba(255,255,255,0.15)' : 'transparent',
                    transition: 'all 0.2s'
                  }
                }))
              };
            } else {
              // Item simples
              return {
                ...item,
                label: (
                  <span style={{
                    fontWeight: 500,
                    fontSize: 15,
                    color: selectedKey.includes(item.key) ? 'white' : 'rgba(255,255,255,0.85)'
                  }}>
                    {item.label}
                  </span>
                ),
                style: {
                  borderRadius: 8,
                  marginBottom: 8,
                  background: selectedKey.includes(item.key) ? 'rgba(255,255,255,0.15)' : 'transparent',
                  transition: 'all 0.2s'
                }
              };
            }
          })}
        />
      </div>

      {/* Perfil do Usuário - fixo no bottom */}
      <div style={{
        width: '100%',
        padding: '16px',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        background: 'rgba(0,0,0,0.1)',
        backdropFilter: 'blur(5px)',
        flexShrink: 0
      }}>
        <Dropdown menu={{ items: userMenuItems }} placement="topRight">
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            padding: '8px 12px',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.2s',
            ':hover': {
              background: 'rgba(255,255,255,0.1)'
            }
          }}>
            {!isCollapsed && (
              <div style={{ marginLeft: '12px' }}>
                <Text strong style={{ 
                  display: 'block', 
                  color: 'white',
                  fontSize: 14
                }}>
                  {nome}
                </Text>
                <Text style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  fontSize: 12 
                }}>
                  {perfil}
                </Text>
              </div>
            )}
          </div>
        </Dropdown>
      </div>
      {!isCollapsed && (
        <div style={{
          textAlign: 'center',
          padding: '8px 0',
          color: 'rgba(255,255,255,0.45)',
          fontSize: 10,
          letterSpacing: 0.3
        }}>
          Desenvolvido por <span style={{ color: 'rgba(255,255,255,0.65)' }}>Mil Vendas</span>
        </div>
      )}
    </>
  );

  return (
    <Layout style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
    }}>
      {/* Sidebar para Desktop */}
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={280}
        collapsedWidth={80}
        breakpoint="lg"
        onBreakpoint={(broken) => {
          // Em telas pequenas, escondemos o Sider
        }}
        style={{
          overflow: 'hidden',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          background: 'linear-gradient(180deg, rgba(249,130,68, 0.95) 0%, rgba(217,68,82, 0.95) 100%)',
          boxShadow: '2px 0 8px rgba(0,0,0,0.1)',
          zIndex: 100,
          transition: 'all 0.3s cubic-bezier(0.2, 0, 0, 1)',
          display: 'flex',
          flexDirection: 'column'
        }}
        className="desktop-sidebar"
      >
        <SidebarContent isCollapsed={collapsed} />
      </Sider>

      {/* Drawer para Mobile */}
      <Drawer
        placement="left"
        onClose={() => setMobileOpen(false)}
        open={mobileOpen}
        width={280}
        styles={{
          body: { 
            padding: 0,
            background: 'linear-gradient(180deg, rgba(249,130,68, 0.95) 0%, rgba(217,68,82, 0.95) 100%)',
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
          }
        }}
        className="mobile-drawer"
      >
        <SidebarContent isCollapsed={false} />
      </Drawer>

      {/* Área de Conteúdo */}
      <Layout style={{ 
        marginLeft: 0,
        transition: 'all 0.3s cubic-bezier(0.2, 0, 0, 1)',
        background: 'transparent'
      }}
      className={`main-layout ${!collapsed ? 'expanded' : ''}`}
      >
        <Header
          style={{
            padding: 0,
            background: 'rgba(255,255,255,0.8)',
            backdropFilter: 'blur(8px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            boxShadow: '0 1px 10px rgba(0,0,0,0.05)',
            position: 'sticky',
            top: 0,
            zIndex: 10,
            borderBottom: '1px solid rgba(0, 0, 0, 0.05)'
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => {
              // Em mobile, abre o drawer
              if (window.innerWidth < 992) {
                setMobileOpen(true);
              } else {
                setCollapsed(!collapsed);
              }
            }}
            style={{
              fontSize: '18px',
              width: 64,
              height: 64,
              color: 'rgba(217,68,82, 0.9)'
            }}
          />
        </Header>

        <Content
          style={{
            margin: '16px',
            padding: '16px',
            minHeight: 280,
            background: 'rgba(255,255,255,0.8)',
            backdropFilter: 'blur(8px)',
            borderRadius: 12,
            boxShadow: '0 1px 10px rgba(0,0,0,0.03)'
          }}
        >
          <Outlet />
        </Content>
      </Layout>

      {/* Estilos CSS globais e responsivos */}
      <style dangerouslySetInnerHTML={{ __html: `
        /* Menu principal */
        .ant-menu {
          background: transparent !important;
        }

        /* Submenu inline (dentro do Sider) */
        .ant-menu-sub.ant-menu-inline {
          background: linear-gradient(180deg, rgba(249,130,68, 0.95) 0%, rgba(217,68,82, 0.95) 100%) !important;
          border-radius: 8px !important;
          margin: 4px 0 !important;
          padding: 6px !important;
          border: none !important;
        }

        /* Itens do submenu inline */
        .ant-menu-sub.ant-menu-inline .ant-menu-item {
          border-radius: 6px !important;
          margin: 4px 0 !important;
          color: rgba(255,255,255,0.85) !important;
          font-weight: 500 !important;
          font-size: 14px !important;
          background: transparent !important;
          transition: all 0.2s ease !important;
        }

        .ant-menu-sub.ant-menu-inline .ant-menu-item:hover {
          background: rgba(255,255,255,0.15) !important;
        }

        .ant-menu-sub.ant-menu-inline .ant-menu-item-selected {
          background: rgba(255,255,255,0.25) !important;
          color: white !important;
        }

        /* Corrigir ícones e setinhas */
        .ant-menu-submenu-title, 
        .ant-menu-submenu-arrow {
          color: rgba(255,255,255,0.9) !important;
        }

        .ant-menu-submenu-title:hover {
          background: rgba(255,255,255,0.1) !important;
        }

        /* Setas do submenu */
        .ant-menu-submenu-arrow::before,
        .ant-menu-submenu-arrow::after {
          background-color: rgba(255,255,255,0.85) !important;
        }

        /* Scrollbar personalizada para webkit browsers */
        .ant-layout-sider::-webkit-scrollbar {
          width: 6px;
        }

        .ant-layout-sider::-webkit-scrollbar-track {
          background: transparent;
        }

        .ant-layout-sider::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.3);
          border-radius: 3px;
        }

        .ant-layout-sider::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.5);
        }

        /* Mobile First - Estilos base para mobile */
        .desktop-sidebar {
          display: none;
        }

        .main-layout {
          margin-left: 0 !important;
        }

        /* Tablet e acima (768px) */
        @media (min-width: 768px) {
          .ant-layout-content {
            margin: 24px !important;
            padding: 24px !important;
          }
        }

        /* Desktop (992px e acima) */
        @media (min-width: 992px) {
          .desktop-sidebar {
            display: flex !important;
          }

          .mobile-drawer {
            display: none;
          }

          .main-layout {
            margin-left: 80px !important;
          }

          .main-layout.expanded {
            margin-left: 280px !important;
          }
        }

        /* Ajuste do layout quando sidebar está expandida */
        @media (min-width: 992px) {
          .ant-layout:has(.ant-layout-sider:not(.ant-layout-sider-collapsed)) .main-layout {
            margin-left: 280px !important;
          }
        }
      ` }} />
      <ToastContainer />
    </Layout>
  );
};

export default Home;